<template>
  <div class="mx-4 my-4 fullWidth">
    <div class="bg-white overflow-hidden shadow rounded-lg fullWidth">
      <div
        class="border-b border-gray-200 px-4 py-3 sm:px-6 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
      >
        <!-- Content goes here -->
        <!-- We use less vertical padding on card headers on desktop than on body sections -->
        Your tweet image
      </div>
      <div class="px-4 py-5 sm:p-6 overflow-x-auto">
        <div
          class="writingCanvas"
          id="editor"
          :style="{ background: color.bgColor }"
        >
          <div
            class="textCanvas p-4 font-extrabold"
            contenteditable="true"
            :style="{ color: color.textColor }"
            @click="resetDefault"
          >
            {{ textBody }}
          </div>
        </div>
        <div class="flex flex-row justify-between">
          <span class="inline-flex rounded-md   my-2">
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-indigo-700  focus:outline-none  transition ease-in-out duration-150"
              @click="downloadImage"
            >
              Download
            </button>
            <button
              type="button"
              class="hidden md:inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-indigo-700  focus:outline-none  transition ease-in-out duration-150"
              @click="copyToClipboard"
            >
              <span v-if="!isCopiedToClipboard">Copy to clipboard</span>
              <span v-if="isCopiedToClipboard">Copied :)</span>
            </button>
          </span>

          <span class="inline-flex rounded-md   my-2">
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none  focus:shadow-outline-indigo  transition ease-in-out duration-150"
              style="background:#00aced"
              @click="shareOnTwitter"
            >
              Send to twitter
            </button>
          </span>
        </div>
      </div>
    </div>
    <Notification :text="notificationText" :show="showNotification" />
    <OnboardingModal
      v-show="showModal"
      :show="showModal"
      @onSuccess="onOnboardingDone"
    />
  </div>
</template>

<script>
import { saveAs } from "file-saver";

import domtoimage from "retina-dom-to-image";

import Notification from "./Notification";
import OnboardingModal from "./OnboardingModal";

export default {
  components: {
    Notification,
    OnboardingModal,
  },
  data() {
    return {
      textBody: "Click me to edit",
      notificationText: "",
      showNotification: false,
      isCopiedToClipboard: false,
      showModal: false,
      isDefaultReseted: false,
    };
  },
  computed: {
    color() {
      return this.$store.getters.getColor;
    },
  },
  methods: {
    downloadImage() {
      const editor = document.querySelector("#editor");
      domtoimage.toBlob(editor).then(function(blob) {
        saveAs(blob, "my-node.png");
      });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    copyToClipboard() {
      const editor = document.querySelector("#editor");
      domtoimage.toBlob(editor).then((blob) => {
        console.log(blob);
        navigator.clipboard
          .write([
            // eslint-disable-next-line
            new ClipboardItem({
              "image/png": blob,
            }),
          ])
          .then(() => {
            this.displayNotification("Image copied to clipboard :)");
          });
      });
    },
    shareOnTwitter() {
      const editor = document.querySelector("#editor");
      const isOnboardingDone = localStorage.getItem("isOnboardingDone");
      domtoimage
        .toBlob(editor)
        .then((blob) => {
          console.log(blob);
          navigator.clipboard
            .write([
              // eslint-disable-next-line
              new ClipboardItem({
                "image/png": blob,
              }),
            ])
            .then(() => {
              if (isOnboardingDone) {
                this.displayNotification(
                  "Image copied to clipboard. Please paste in your tweet composer"
                );
                setTimeout(() => {
                  window.open(
                    `https://twitter.com/intent/tweet?text=https://getpersonal.io/&via=getpersonalio`,
                    "_new"
                  );
                }, 3000);
              } else {
                this.showModal = true;
              }
            });
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
    },
    onOnboardingDone() {
      this.showModal = false;

      window.open(
        `https://twitter.com/intent/tweet?text=https://getpersonal.io/&via=getpersonalio`,
        "_new"
      );
      localStorage.setItem("isOnboardingDone", true);
    },
    resetDefault() {
      if (this.isDefaultReseted === false) {
        this.textBody = "";
        this.isDefaultReseted = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .fullWidth {
    width: 100%;
  }
  .writingCanvas {
    // width: 100% !important;
    width: 300px !important;
    height: 150px !important;
  }
  .textCanvas {
    font-size: 12px !important;
  }
}
.writingCanvas {
  width: 484px;
  height: 242px;
  background: #ceb5a7;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textCanvas {
  text-align: center;
  min-width: 100%;
  font-size: 24px;
  &:focus {
    outline: none;
  }
}
</style>
